<template></template>
<script>
import { mapActions } from "vuex"

export default {
  methods: {
    ...mapActions(["logout"]),
  },
  async created() {
    this.$gtag.event("logout")

    try {
      await this.logout()
    } catch (error) {
      console.error("로그아웃 실패:", error)
    }

    this.$router.replace("/")
  },
}
</script>
